module.exports = __webpack_public_path__ + "img/iPhone.fd5608ba.svg";